export default "__VITE_ASSET__DOAB2tNO__"